module.exports = __webpack_public_path__ + "static/media/014yhkgl.3314d70a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/014yhkgl.jpg
// module id = 633
// module chunks = 0 1